import { cn } from '../../../utils';

import type { HTMLAttributes } from 'react';

const Divider = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <hr {...props} className={cn('my-1 border-solid border-border-neutral', className)} />
);

export default Divider;
